import { Routes, Route } from "react-router-dom";
import { MainLayout } from "@/components/layout/MainLayout";
import {
  AboutPage,
  AccountPage,
  ApplyPage,
  BlogPage,
  BlogPostPage,
  BrandModelPage,
  BrandModelYearPage,
  BrandComparisonPage,
  BrandPage,
  BrandsPage,
  CompareHubPage,
  FavoritesPage,
  FinancingPage,
  HomePage,
  NotFoundPage,
  PurchasePage,
  ShopCityPage,
  ShopPage,
  ShopSlugPage,
  TradeInPage,
  VehicleDetailPage,
  VehiclesPage,
} from "@/pages";

function App() {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path="vehicles" element={<VehiclesPage />} />
        <Route path="vehicles/:id" element={<VehicleDetailPage />} />
        <Route path="brands" element={<BrandsPage />} />
        <Route path="brands/compare" element={<CompareHubPage />} />
        <Route
          path="brands/compare/:comparison"
          element={<BrandComparisonPage />}
        />
        <Route path="brands/:brand" element={<BrandPage />} />
        <Route path="brands/:brand/:model" element={<BrandModelPage />} />
        <Route path="brands/:brand/:model/:year" element={<BrandModelYearPage />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="shop/:state/:city" element={<ShopCityPage />} />
        <Route path="shop/:slug" element={<ShopSlugPage />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog/:slug" element={<BlogPostPage />} />
        <Route path="financing" element={<FinancingPage />} />
        <Route path="trade-in" element={<TradeInPage />} />
        <Route path="apply" element={<ApplyPage />} />
        <Route path="purchase/:vehicleId" element={<PurchasePage />} />
        <Route path="favorites" element={<FavoritesPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
